<template>
  <div class="login-wrapper">
    <div class="content">
      <slot name="content"></slot>
    </div>
    <div class="paper element">
      <img :src="paperImg" alt="" />
    </div>
    <div class="satelite element">
      <img :src="sateliteImg" alt="" />
    </div>
    <div class="astronaut element">
      <img :src="astronautImg" alt="" />
    </div>
    <div class="paper02 element">
      <img :src="paper2Img" alt="" />
    </div>
    <div class="shape">
      <div class="word01 spin02">
        <img :src="earthImg" alt="" />
      </div>
      <div class="word01 spin">
        <img :src="cloudImg" alt="" />
      </div>
      <img :src="shapeImg" alt="" />
    </div>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import paperImg from '@/assets/images/login/paper.svg'
import sateliteImg from '@/assets/images/login/satelite.svg'
import astronautImg from '@/assets/images/login/astronaut.svg'
import paper2Img from '@/assets/images/login/paper02.svg'
import earthImg from '@/assets/images/login/word.svg'
import cloudImg from '@/assets/images/login/cloud.svg'
import shapeImg from '@/assets/images/login/shape.svg'

export default {
  data() {
    return {
      paperImg,
      sateliteImg,
      astronautImg,
      paper2Img,
      earthImg,
      cloudImg,
      shapeImg,
    }
  },
}
</script>

<style lang="scss" scoped>
div.login-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #0c243f url('../../../assets/images/login/stars.svg') !important;
  background-position: center;
  background-size: cover;
  background-repeat: space;
  height: 100%;
}

.content {
  justify-self: center;
  align-self: center;
  z-index: 99;
}

.footer {
  text-align: center;
  font-size: 11px;
  color: $color-white;
  z-index: 99;
  padding: 20px 0;

  p {
    margin: 0;
  }
}

.element {
  height: auto;
  position: absolute;
  transform: translatey(0px);
  animation: float 6s ease-in-out infinite;
}

.satelite {
  width: 180px;
  top: 30%;
  left: 15%;
  z-index: 2;
}

.astronaut {
  width: 200px;
  top: 65%;
  right: 6%;
  animation-delay: 2s;
}

.paper02 {
  width: 40px;
  bottom: 10%;
  right: 15%;
  animation-delay: 1.5s;
}

.paper {
  width: 70px;
  top: 8%;
  left: 8%;
  animation-delay: 1.5s;
}

.shape {
  width: 60%;
  bottom: 0%;
  height: 350px;
  left: -5%;
  animation-delay: 1s;
  overflow: hidden;
  position: absolute;
}

.word01 {
  top: 10%;
  width: 50%;
  height: 450px;
  position: absolute;
}

.spin {
  -webkit-animation: spin 850s infinite linear;
}

.spin02 {
  -webkit-animation: spin02 650s infinite linear;
}

img {
  width: 100%;
}

@keyframes float {
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-20px);
  }
  100% {
    transform: translatey(0px);
  }
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin02 {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(-360deg);
  }
}
</style>
